/**
 * @file All navigator callbacks used for generating proxy links
 */

import { getChatConversationUrl } from '../../../urls/chat';
import {
  getMessageDetailsRepliesUrl,
  getMessageDetailsUrl,
} from '../../../urls/message';
import {
  getSettingsGroupsUrl,
  getSettingsLabelsUrl,
  getSettingsPeopleUrl,
  getSettingsTopicsUrl,
} from '../../../urls/settings';
import { getTopicUrl } from '../../../urls/topic';
import { NavigationFunction } from '../types';

/**
 * Returns a URL for a chat conversation
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorChatConversation: NavigationFunction = params => {
  return getChatConversationUrl(params.conversationId, params.hotelId);
};

/**
 * Returns a URL for a message with replies expanded
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorComment: NavigationFunction = params => {
  const navigatorParams = null;
  const { hotelId, messageId, topicId } = params;
  return getMessageDetailsRepliesUrl(
    hotelId,
    navigatorParams,
    messageId,
    topicId,
  );
};

/**
 * Returns a URL for a label settings
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorLabel: NavigationFunction = params => {
  // Passing false will keep the left sidebar opened by default
  const isTablet = false;
  return getSettingsLabelsUrl(params.hotelId, isTablet);
};

/**
 * Returns a URL for a message detail
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorMessage: NavigationFunction = params => {
  const navigatorParams = null;
  // Passing true will keep the left sidebar closed by default since we want to show right sidebar
  const isTablet = true;
  const { hotelId, messageId, topicId } = params;
  return getMessageDetailsUrl(
    hotelId,
    isTablet,
    navigatorParams,
    messageId,
    topicId,
  );
};

/**
 * Returns a URL for a topic navigation
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorTopicMain: NavigationFunction = params => {
  const searchParams = null;
  const { hotelId, topicId } = params;
  return getTopicUrl(hotelId, searchParams, topicId);
};

/**
 * Returns a URL for a topic settings
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorTopicSettings: NavigationFunction = params => {
  // Passing false will keep the left sidebar opened by default
  const isTablet = false;
  return getSettingsTopicsUrl(params.hotelId, isTablet);
};

/**
 * Returns a URL for a user settings
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorUser: NavigationFunction = params => {
  // Passing false will keep left sidebar opened by default
  const isTablet = false;
  return getSettingsPeopleUrl(params.hotelId, isTablet);
};

/**
 * Returns a URL for a group settings
 *
 * @param params The search params
 * @returns      Generated URL
 */
export const navigatorUserGroup: NavigationFunction = params => {
  // Passing false will keep left sidebar opened by default
  const isTablet = false;
  return getSettingsGroupsUrl(params.hotelId, isTablet);
};
